// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__ZzwY1","actions__call":"styles_actions__call__T0UKN","actions__share":"styles_actions__share___FNwj","actions__connect":"styles_actions__connect__kQPSw"};